export default __webpack_public_path__ + "static/media/Mark-5-HUD-07.ead0372c.jpg";